import React, { useEffect } from 'react'

import Header from '../../../components/Arabic/Header/Header'
import UnderHeader from '../../../components/UnderHeader/UnderHeader'
import PageTitle from '../../../components/Arabic/PageTitle/PageTitle'
import Footer from '../../../components/Arabic/Footer/Footer'
import LogoPartner from '../../../components/LogoPartner/LogoPartner'
import ProductsItem from '../../../components/Arabic/ProductsItem/ProductsItem'

export default function Products() {
  useEffect(() => {
    window.scrollTo({ top:0 ,behavior: "smooth" })
  }, [])

  return (
    <>
      <Header page={'products'} />
      <UnderHeader className={'products'} />
      <PageTitle mainTitle={'منتجاتنا'} page={'منتجاتنا'} />
      <ProductsItem />
      <LogoPartner />
      <Footer />
    </>
  )
}
